/**
 * Shared MagSafe / magnetic phone catalog + pickers.
 * Used by:
 *   - snippets/phone-magnetic-compat.liquid  ([data-phone-magnetic-compat])
 *   - sections/qi2-compat-checker.liquid     ([data-phone-case-finder])
 * Edit phones / case URLs here only.
 */
(function (global) {
  'use strict';

  // Brand → series → model. Keep lists short at each step.
  // wireless: true | false | 'unknown' — phone must support Qi/wireless charging to use pads / MagSafe banks.
  // magnet: 'native' (MagSafe/Qi2) | 'case' (needs magnetic case) | 'unknown'
  var CATALOG = {
    apple: {
      label: 'Apple',
      filter: 'brand:apple',
      series: [
        { label: 'iPhone 17', wireless: true, magnet: 'native', models: ['iPhone 17', 'iPhone 17 Air', 'iPhone 17 Pro', 'iPhone 17 Pro Max'] },
        { label: 'iPhone 16', wireless: true, magnet: 'native', models: ['iPhone 16', 'iPhone 16 Pro', 'iPhone 16 Pro Max'] },
        { label: 'iPhone 15', wireless: true, magnet: 'native', models: ['iPhone 15', 'iPhone 15 Pro', 'iPhone 15 Pro Max'] },
        { label: 'iPhone 14', wireless: true, magnet: 'native', models: ['iPhone 14', 'iPhone 14 Pro', 'iPhone 14 Pro Max'] },
        { label: 'iPhone 13', wireless: true, magnet: 'native', models: ['iPhone 13', 'iPhone 13 Pro', 'iPhone 13 Pro Max'] },
        { label: 'iPhone 12', wireless: true, magnet: 'native', models: ['iPhone 12', 'iPhone 12 Pro', 'iPhone 12 Pro Max'] }
      ]
    },
    samsung: {
      label: 'Samsung',
      filter: 'brand:samsung',
      series: [
        { label: 'Galaxy S25', wireless: true, magnet: 'case', models: ['Galaxy S25', 'Galaxy S25+', 'Galaxy S25 Ultra'] },
        { label: 'Galaxy S24', wireless: true, magnet: 'case', models: ['Galaxy S24', 'Galaxy S24+', 'Galaxy S24 Ultra'] },
        { label: 'Galaxy S23', wireless: true, magnet: 'case', models: ['Galaxy S23', 'Galaxy S23 FE', 'Galaxy S23+', 'Galaxy S23 Ultra'] },
        { label: 'Galaxy S22', wireless: true, magnet: 'case', models: ['Galaxy S22', 'Galaxy S22+', 'Galaxy S22 Ultra'] },
        { label: 'Galaxy S21 FE', wireless: true, magnet: 'case', models: ['Galaxy S21 FE'] }
      ]
    },
    google: {
      label: 'Google',
      filter: 'brand:google',
      series: [
        { label: 'Pixel 10', wireless: true, magnet: 'native', models: ['Pixel 10', 'Pixel 10 Pro', 'Pixel 10 Pro XL'] },
        { label: 'Pixel 9', wireless: true, magnet: 'case', models: ['Pixel 9', 'Pixel 9a', 'Pixel 9 Pro', 'Pixel 9 Pro XL'] },
        { label: 'Pixel 8', wireless: true, magnet: 'case', models: ['Pixel 8', 'Pixel 8a', 'Pixel 8 Pro'] },
        { label: 'Pixel 7', wireless: true, magnet: 'case', models: ['Pixel 7', 'Pixel 7a', 'Pixel 7 Pro'] },
        { label: 'Pixel 6', wireless: true, magnet: 'case', models: ['Pixel 6', 'Pixel 6a', 'Pixel 6 Pro'] }
      ]
    },
    other: {
      label: 'Other',
      filter: 'brand:other',
      series: [
        { label: 'Other Android', wireless: 'unknown', magnet: 'unknown', models: ['Other Android'] },
        { label: 'Other phone', wireless: 'unknown', magnet: 'unknown', models: ['Other phone'] }
      ]
    }
  };

  function findSeries(brand, model) {
    var list = seriesList(brand);
    for (var i = 0; i < list.length; i++) {
      var series = list[i];
      var models = series.models || [];
      if (models.indexOf(model) !== -1) return series;
      if (series.label === model) return series;
    }
    return null;
  }

  function phoneCaps(brand, model) {
    var series = findSeries(brand, model) || {};
    var brandDefault = CATALOG[brand] || {};
    return {
      wireless: series.wireless != null ? series.wireless : brandDefault.wireless != null ? brandDefault.wireless : 'unknown',
      magnet: series.magnet || brandDefault.magnet || 'unknown'
    };
  }

  function seriesList(brand) {
    var entry = CATALOG[brand] || {};
    if (entry.series && entry.series.length) return entry.series;
    // Legacy flat models → one series per model
    return (entry.models || []).map(function (m) {
      return { label: m, models: [m] };
    });
  }

  function shortModelLabel(seriesLabel, model) {
    if (!model) return model;
    if (model === seriesLabel) return 'Standard';
    if (model.indexOf(seriesLabel + ' ') === 0) {
      return model.slice(seriesLabel.length + 1);
    }
    return model;
  }

  var DEFAULT_URLS = {
    cases: '/collections/phone-cases',
    iphone: '/products/solid-color-all-inclusive-magnetic-phone-case-nano-frosted-glass-for-magsafe-phone-case-for-i-phone-17-air-16-15-14-13-pro-max-magnetic-wireless-charge-armor-cover',
    samsungMain: '/products/applicable-to-s25ultra-fine-circle-magnetic-suction-phone-case-frosted-all-inclusive-s24-soft-edge',
    samsungOlder: '/products/applicable-to-s24-phone-case-magnetic-suction-galaxys23ultra-oil-injection-skin-feeling-matte',
    samsungKick: '/products/applicable-to-s25ultra-magnetic-suction-phone-case-magsafe-oblique-turning-bracket',
    pixel: '/products/simple-solid-color-pixel-678-magnetic-cloth-pattern-all-inclusive-phone-case',
    wallet: '/products/android-universal-phone-magnetic-card-holder-magsafe-magnetic-ring-pu-leather',
    bank: '/products/power-bank-magsafe-magnetic-wireless-charger-5000-ma',
    case15: '/pages/case15?discount=CASE15'
  };

  function urlsFromRoot(root) {
    var d = root.dataset || {};
    return {
      cases: d.urlCases || DEFAULT_URLS.cases,
      iphone: d.urlIphone || DEFAULT_URLS.iphone,
      samsungMain: d.urlSamsungMain || DEFAULT_URLS.samsungMain,
      samsungOlder: d.urlSamsungOlder || DEFAULT_URLS.samsungOlder,
      samsungKick: d.urlSamsungKick || DEFAULT_URLS.samsungKick,
      pixel: d.urlPixel || DEFAULT_URLS.pixel,
      wallet: d.urlWallet || DEFAULT_URLS.wallet,
      bank: d.urlBank || DEFAULT_URLS.bank,
      case15: d.urlCase15 || DEFAULT_URLS.case15
    };
  }


  function parseCaseCatalog(root) {
    try {
      var raw = root.getAttribute('data-case-catalog');
      if (!raw) return null;
      // attribute may be HTML-escaped
      var ta = document.createElement('textarea');
      ta.innerHTML = raw;
      return JSON.parse(ta.value);
    } catch (e) {
      return null;
    }
  }

  function moneyFromCents(cents) {
    var n = Number(cents) / 100;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(n);
    } catch (e) {
      return '£' + n.toFixed(2);
    }
  }

  function saleCents(cents, pct) {
    return Math.round(Number(cents) * (100 - Number(pct || 15)) / 100);
  }

  function caseKeyFor(brand, model) {
    if (brand === 'apple') return 'iphone';
    if (brand === 'google') return 'pixel';
    if (brand === 'samsung') {
      // S23 FE is only on the older S21–S24 case product
      if (/s21|s22|s23\s*fe/i.test(model || '')) return 'samsungOlder';
      return 'samsungMain';
    }
    return null;
  }

  function modelLookupKeys(model) {
    var m = String(model || '').trim();
    var keys = m ? [m] : [];
    // Pixel PDP options combine base + Pro on one variant value
    if (m === 'Pixel 10' || m === 'Pixel 10 Pro') keys.push('Pixel 10 / 10 Pro');
    if (m === 'Pixel 9' || m === 'Pixel 9 Pro') keys.push('Pixel 9 / 9 Pro');
    return keys;
  }

  function colourEntries(modelEntry, caseObj) {
    if (!modelEntry) return [];
    var colours = modelEntry.colours;
    if (colours && typeof colours === 'object') {
      return Object.keys(colours).map(function (name) {
        var c = colours[name] || {};
        return {
          name: name,
          variantId: c.v || c.variantId,
          price: c.p != null ? c.p : c.price,
          available: c.a != null ? c.a : c.available !== false,
          image: c.i || c.image || (caseObj && caseObj.image) || null
        };
      }).filter(function (c) { return !!c.variantId; });
    }
    if (modelEntry.variantId) {
      return [{
        name: 'Default',
        variantId: modelEntry.variantId,
        price: modelEntry.price,
        available: modelEntry.available !== false,
        image: modelEntry.image || (caseObj && caseObj.image) || null
      }];
    }
    return [];
  }

  function hydrateModelEntry(caseObj, modelEntry) {
    if (!modelEntry) return null;
    var colours = colourEntries(modelEntry, caseObj);
    var first = colours[0] || null;
    return Object.assign({}, caseObj, modelEntry, {
      colours: colours,
      variantId: (first && first.variantId) || modelEntry.variantId || caseObj.variantId,
      price: first ? first.price : modelEntry.price != null ? modelEntry.price : caseObj.price,
      available: first ? first.available : modelEntry.available,
      image: (first && first.image) || modelEntry.image || caseObj.image
    });
  }

  /** Resolve catalog entry to the model entry matching the selected phone model. */
  function resolveCaseForModel(caseObj, model) {
    if (!caseObj) return null;
    var by = caseObj.byModel || null;
    if (!by || !Object.keys(by).length) {
      return caseObj.variantId ? hydrateModelEntry(caseObj, caseObj) : null;
    }
    var keys = modelLookupKeys(model);
    var i;
    for (i = 0; i < keys.length; i++) {
      if (by[keys[i]]) return hydrateModelEntry(caseObj, by[keys[i]]);
    }
    var needle = String(model || '')
      .toLowerCase()
      .replace(/\+/g, ' plus ')
      .replace(/\s+/g, ' ')
      .trim();
    var names = Object.keys(by);
    for (i = 0; i < names.length; i++) {
      var key = names[i];
      var hay = key
        .toLowerCase()
        .replace(/\+/g, ' plus ')
        .replace(/\s+/g, ' ')
        .trim();
      if (hay === needle) return hydrateModelEntry(caseObj, by[key]);
    }
    for (i = 0; i < names.length; i++) {
      key = names[i];
      hay = key
        .toLowerCase()
        .replace(/\+/g, ' plus ')
        .replace(/\s+/g, ' ')
        .trim();
      if (hay.indexOf(needle) !== -1 || needle.indexOf(hay) !== -1) {
        return hydrateModelEntry(caseObj, by[key]);
      }
    }
    return null;
  }

  function selectedPowerBankVariantId() {
    var root =
      document.querySelector('[data-phone-magnetic-compat][data-compat-mode="power_bank"]') ||
      document.querySelector('[data-phone-magnetic-compat]');
    var form =
      (root && root.closest('.shopify-section, product-info, .product')) ||
      document.querySelector('product-info, .product-information, .product');
    var scope = form || document;
    var input =
      scope.querySelector('product-form [name="id"]') ||
      scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
      scope.querySelector('[name="id"][form]') ||
      document.querySelector('product-form [name="id"]');
    if (!input) return null;
    var id = Number(input.value || input.getAttribute('value') || 0);
    return id || null;
  }

  function setAddButtonLabel(btn, label) {
    if (!btn) return;
    var cta = btn.querySelector('.mcu__card-cta');
    if (cta) {
      cta.textContent = label;
      return;
    }
    btn.textContent = label;
  }

  function cartRootPath() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function collectCartSectionIds() {
    var ids = ['cart-drawer-section'];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /**
   * Cart Ajax sometimes returns Cloudflare/Shopify HTML challenges instead of JSON
   * (esp. FB in-app browser / bursty cart traffic). Never call response.json() raw.
   */
  function readCartJson(response) {
    return response.text().then(function (text) {
      var trimmed = String(text || '').replace(/^\uFEFF/, '').trim();
      if (!trimmed) {
        throw new Error('Empty cart response');
      }
      if (trimmed.charAt(0) === '<') {
        var challenge =
          /verifying your connection|cf-browser-verification|just a moment|attention required/i.test(
            trimmed
          );
        throw new Error(
          challenge
            ? 'Store security check interrupted the cart. Refresh the page (or open in Safari/Chrome) and try again.'
            : 'Cart returned a page instead of data. Refresh and try again.'
        );
      }
      try {
        return JSON.parse(trimmed);
      } catch (e) {
        throw new Error('Cart returned invalid data. Refresh and try again.');
      }
    });
  }

  function cartFetch(url, options) {
    options = options || {};
    var headers = Object.assign(
      { Accept: 'application/json' },
      options.headers || {}
    );
    return fetch(url, Object.assign({}, options, { credentials: 'same-origin', headers: headers })).then(
      function (r) {
        return readCartJson(r).then(function (j) {
          if (!r.ok) {
            throw new Error((j && (j.description || j.message)) || 'Cart request failed');
          }
          return j;
        });
      }
    );
  }

  function fetchCartJson() {
    return cartFetch(cartRootPath() + 'cart.js');
  }

  /**
   * Update cart-drawer content without replaceWith on the section root.
   * Full section replace destroys Horizon theme-drawer / cart-drawer-component
   * while open (blank sidebar, stuck overlay, dead close button).
   */
  function softMorphCartDrawerSection(existingSection, newSection) {
    // Always swap cart-items-component when present. innerHTML-only morphs leave Horizon
    // custom elements half-dead after the first update (UI freezes on the first paint).
    var oldComp = existingSection.querySelector('cart-items-component');
    var newComp = newSection.querySelector('cart-items-component');
    if (oldComp && newComp) {
      oldComp.replaceWith(newComp);
    } else {
      var items = existingSection.querySelector('.cart-drawer__items');
      var nextItems = newSection.querySelector('.cart-drawer__items');
      if (items && nextItems) items.innerHTML = nextItems.innerHTML;
    }

    var pairs = [
      ['.cart-drawer__summary', '.cart-drawer__summary'],
      ['#cart-drawer-heading', '#cart-drawer-heading'],
    ];
    for (var i = 0; i < pairs.length; i++) {
      var oldEl = existingSection.querySelector(pairs[i][0]);
      var newEl = newSection.querySelector(pairs[i][1]);
      if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
    }

    var oldInner = existingSection.querySelector('.cart-drawer__inner');
    var newInner = newSection.querySelector('.cart-drawer__inner');
    if (oldInner && newInner) {
      oldInner.className = newInner.className;
    }
  }

  function applySectionsHtml(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      var el = document.getElementById('shopify-section-' + id);
      if (!el || !html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var next = tmp.firstElementChild;
      if (!next) return;

      var isCartDrawer =
        id === 'cart-drawer-section' ||
        !!el.querySelector('cart-drawer-component, theme-drawer#cart-drawer, #cart-drawer');
      if (isCartDrawer) {
        softMorphCartDrawerSection(el, next);
        return;
      }
      el.replaceWith(next);
    });
  }

  function fetchCartSections() {
    var ids = collectCartSectionIds();
    // Keep commas literal — encodeURIComponent on the joined list breaks Section Rendering.
    return cartFetch(cartRootPath() + '?sections=' + ids.map(encodeURIComponent).join(',')).catch(
      function () {
        return {};
      }
    );
  }

  function refreshCartSections() {
    return fetchCartSections().then(function (data) {
      applySectionsHtml(data);
      return data;
    });
  }

  function updateCartBubble(cart) {
    var count = cart && cart.item_count != null ? Number(cart.item_count) : null;
    if (count == null || isNaN(count)) return;

    // Prefer Horizon <cart-icon>.renderCartBubble — it animates then clears
    // cart-bubble--animating. Leaving that class on parks the count at translateY(-1em).
    var icons = document.querySelectorAll('cart-icon');
    if (icons.length) {
      icons.forEach(function (icon) {
        if (typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(count, true);
        }
      });
      return;
    }

    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = count < 100 ? String(count) : '';
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', count === 0);
      el.classList.remove('cart-bubble--animating');
    });
    document.querySelectorAll('.header-actions__cart-icon, cart-icon').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
  }

  /**
   * Run a cart mutation once, morph drawer/cart sections, notify listeners.
   * Does not depend on @shopify/events (that path double-ran on resolve errors).
   * opts: { run: () => Promise<{cart, sections}> }
   */
  function notifyCartLinesUpdate(opts) {
    opts = opts || {};
    var run = opts.run;
    if (typeof run !== 'function') return Promise.reject(new Error('notifyCartLinesUpdate needs run()'));

    return run().then(function (result) {
      var sections = (result && result.sections) || {};
      var hasSections = Object.keys(sections).length > 0;
      var finish = function () {
        if (result && result.cart) updateCartBubble(result.cart);
        document.dispatchEvent(new CustomEvent('cart:update'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return result;
      };
      if (hasSections) {
        applySectionsHtml(sections);
        return finish();
      }
      return refreshCartSections().then(finish);
    });
  }

  function openCartDrawer() {
    var onCartPage = window.location && /\/cart\/?$/.test(window.location.pathname || '');
    if (onCartPage) return;
    var drawer = document.querySelector(
      'cart-drawer-component, theme-drawer#cart-drawer, #cart-drawer'
    );
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (drawer.showModal) drawer.showModal();
    else {
      var td = document.getElementById('cart-drawer');
      if (td && typeof td.open === 'function') td.open();
    }
  }

  function cartAdd(items) {
    // Light mutation only — no section HTML in the POST (avoids heavier WAF trips).
    return cartFetch(cartRootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    });
  }

  function cartChange(line, quantity) {
    return cartFetch(cartRootPath() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
  }

  function cartUpdate(updates) {
    return cartFetch(cartRootPath() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
  }

  function cartAddWithSections(items) {
    // Fetch sections only — notifyCartLinesUpdate applies once (avoids double morph).
    return cartAdd(items).then(function (j) {
      return fetchCartSections().then(function (sections) {
        return Object.assign({}, j, { sections: sections || {} });
      });
    });
  }

  function cartChangeWithSections(line, quantity) {
    return cartChange(line, quantity).then(function (j) {
      return fetchCartSections().then(function (sections) {
        return Object.assign({}, j, { sections: sections || {} });
      });
    });
  }

  function addToCartItems(items, btn, doneLabel) {
    if (!items || !items.length) return Promise.reject(new Error('Missing variant'));
    var normalized = items
      .map(function (it) {
        return { id: Number(it.id), quantity: Number(it.quantity) || 1 };
      })
      .filter(function (it) {
        return it.id > 0;
      });
    if (!normalized.length) return Promise.reject(new Error('Missing variant'));
    if (btn) {
      btn.disabled = true;
      var cta = btn.querySelector('.mcu__card-cta');
      btn.dataset.prevLabel = cta ? cta.textContent : btn.textContent;
      setAddButtonLabel(btn, 'Adding…');
    }
    var lines = normalized.map(function (it) {
      return { merchandiseId: String(it.id), quantity: it.quantity };
    });
    return notifyCartLinesUpdate({
      action: 'add',
      context: 'phone-magnetic-compat',
      lines: lines,
      run: function () {
        return cartAddWithSections(normalized).then(function (addResp) {
          return fetchCartJson().then(function (cart) {
            return {
              cart: cart,
              sections: (addResp && addResp.sections) || {},
            };
          });
        });
      },
    })
      .then(function () {
        openCartDrawer();
        if (btn) {
          setAddButtonLabel(btn, doneLabel || 'Added');
          setTimeout(function () {
            btn.disabled = false;
            setAddButtonLabel(btn, btn.dataset.prevLabel || 'Add case · 15% off');
          }, 1600);
        }
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          setAddButtonLabel(btn, btn.dataset.prevLabel || 'Add case · 15% off');
        }
        alert(err.message || 'Could not add case');
      });
  }

  function addToCartVariant(variantId, btn) {
    return addToCartItems([{ id: Number(variantId), quantity: 1 }], btn);
  }

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function swatchStyle(colourName) {
    var n = String(colourName || '').toLowerCase();
    var map = {
      black: '#1a1a1a',
      'classic black': '#1a1a1a',
      'graphite black': '#2b2b2b',
      green: '#3d7a4a',
      orange: '#e07a2f',
      'vibrant orange': '#e07a2f',
      purple: '#6b4c9a',
      'dark night purple': '#4a2f6b',
      'dark purple': '#4a2f6b',
      'blue and green': 'linear-gradient(135deg,#2f6f9f 45%,#3d7a4a 55%)',
      gray: '#8a8a8a',
      grey: '#8a8a8a',
      'silver gray': '#a8aeb4',
      'titanium gray': '#8b9096',
      'titanium silver': '#c5c8cc',
      'dark blue': '#1f3a66',
      'navy blue': '#1f3a66',
      'desert gold': '#c2a46b',
      white: '#f2f2f2',
      brown: '#6b4634',
      blue: '#2f6f9f',
      silver: '#c5c8cc',
      'sapphire blue': '#1f4f8a',
      'wine red': '#7a2432'
    };
    var fill = map[n] || '#d0d0d0';
    if (fill.indexOf('gradient') !== -1) return 'background:' + fill;
    return 'background-color:' + fill;
  }

  function casePickerHtml(caseObj, label, pct, model, opts) {
    opts = opts || {};
    var resolved = model ? resolveCaseForModel(caseObj, model) : null;
    if (!resolved || !(resolved.colours && resolved.colours.length) || !resolved.variantId) {
      if (!caseObj) return '';
      return (
        '<p class="pmc__note">No exact case variant for that model yet. ' +
        '<a class="pmc__cta" href="' +
        (caseObj.url || DEFAULT_URLS.cases) +
        '">Pick model on the case page</a></p>'
      );
    }
    var colours = resolved.colours;
    var first = colours[0];
    var showSale = Number(pct) > 0;
    var list = moneyFromCents(first.price);
    var sale = moneyFromCents(saleCents(first.price, pct));
    var title = label + (model ? ' · ' + model : '');
    var img = first.image || resolved.image || caseObj.image;
    var uid = 'pmc-' + String(resolved.handle || label).replace(/[^a-z0-9]+/gi, '-') + '-' +
      String(model || 'x').replace(/[^a-z0-9]+/gi, '-');
    // PDP-style circular colour chips (legend shows the name; hero shows the product).
    var swatches = colours.map(function (c, idx) {
      return (
        '<button type="button" class="pmc__swatch' +
        (idx === 0 ? ' is-selected' : '') +
        '" data-pmc-colour="' +
        escAttr(c.name) +
        '" data-pmc-variant="' +
        escAttr(c.variantId) +
        '" data-pmc-price="' +
        escAttr(c.price) +
        '" data-pmc-image="' +
        escAttr(c.image || '') +
        '" data-pmc-available="' +
        (c.available === false ? '0' : '1') +
        '" style="' +
        swatchStyle(c.name) +
        '" title="' +
        escAttr(c.name) +
        '" aria-label="' +
        escAttr(c.name) +
        '" aria-pressed="' +
        (idx === 0 ? 'true' : 'false') +
        '"></button>'
      );
    }).join('');
    var priceHtml = showSale
      ? '<p class="pmc__price" data-pmc-price-line><s data-pmc-list>' +
        list +
        '</s><strong data-pmc-sale>' +
        sale +
        '</strong> with a power bank</p>'
      : '<p class="pmc__price" data-pmc-price-line><strong data-pmc-sale>' + list + '</strong></p>';
    var withBank =
      opts.withPowerBank
        ? '<button type="button" class="pmc__cta pmc__cta--primary" data-pmc-add-with-bank' +
          (first.available === false ? ' disabled' : '') +
          '>Add power bank + case' +
          (showSale ? ' · 15% on case' : '') +
          '</button>'
        : '';
    var caseOnlyLabel = showSale ? 'Add case · 15% off' : 'Add case';
    return (
      '<div class="pmc__case" data-pmc-case-picker data-pmc-pct="' +
      escAttr(pct || 0) +
      '" data-pmc-uid="' +
      escAttr(uid) +
      '">' +
      '<div class="pmc__case-media">' +
      (img
        ? '<img data-pmc-case-img src="' +
          escAttr(img) +
          '" alt="' +
          escAttr(title) +
          '" width="1600" height="1600" loading="lazy" decoding="async">'
        : '<div class="pmc__case-ph" aria-hidden="true"></div>') +
      '</div>' +
      '<div class="pmc__case-body">' +
      '<p class="pmc__case-title">' +
      escAttr(title) +
      '</p>' +
      '<p class="pmc__case-colour">Colour: <strong data-pmc-colour-label>' +
      escAttr(first.name) +
      '</strong></p>' +
      '<div class="pmc__swatches" role="group" aria-label="Case colour">' +
      swatches +
      '</div>' +
      priceHtml +
      '<div class="pmc__ctas">' +
      withBank +
      '<button type="button" class="pmc__cta' +
      (opts.withPowerBank ? '' : ' pmc__cta--primary') +
      '" data-pmc-add-variant="' +
      escAttr(first.variantId) +
      '"' +
      (first.available === false ? ' disabled' : '') +
      '>' +
      caseOnlyLabel +
      '</button>' +
      '<a class="pmc__cta" href="' +
      escAttr(resolved.url || caseObj.url || '#') +
      '">View case</a>' +
      '</div>' +
      '</div></div>'
    );
  }

  function caseOfferBlock(caseObj, label, pct, model) {
    return casePickerHtml(caseObj, label, pct, model, { withPowerBank: true });
  }

  function bindCasePickers(root) {
    if (!root) return;
    root.querySelectorAll('[data-pmc-case-picker]').forEach(function (picker) {
      if (picker.dataset.pickerBound) return;
      picker.dataset.pickerBound = '1';
      var pct = Number(picker.getAttribute('data-pmc-pct') || 0);
      var img = picker.querySelector('[data-pmc-case-img]');
      var colourLabel = picker.querySelector('[data-pmc-colour-label]');
      var listEl = picker.querySelector('[data-pmc-list]');
      var saleEl = picker.querySelector('[data-pmc-sale]');
      var addBtn = picker.querySelector('[data-pmc-add-variant]');
      var withBankBtn = picker.querySelector('[data-pmc-add-with-bank]');

      function applyColour(btn) {
        if (!btn) return;
        picker.querySelectorAll('[data-pmc-colour]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var variantId = btn.getAttribute('data-pmc-variant');
        var price = Number(btn.getAttribute('data-pmc-price') || 0);
        var image = btn.getAttribute('data-pmc-image') || '';
        var available = btn.getAttribute('data-pmc-available') !== '0';
        var name = btn.getAttribute('data-pmc-colour') || '';
        if (colourLabel) colourLabel.textContent = name;
        if (img && image) img.src = image;
        if (listEl) listEl.textContent = moneyFromCents(price);
        if (saleEl) {
          saleEl.textContent = pct > 0 ? moneyFromCents(saleCents(price, pct)) : moneyFromCents(price);
        }
        if (addBtn) {
          addBtn.setAttribute('data-pmc-add-variant', variantId);
          addBtn.disabled = !available;
        }
        if (withBankBtn) withBankBtn.disabled = !available;
      }

      picker.querySelectorAll('[data-pmc-colour]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyColour(btn);
        });
      });

      if (withBankBtn) {
        withBankBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var caseId = addBtn && addBtn.getAttribute('data-pmc-add-variant');
          var bankId = selectedPowerBankVariantId();
          if (!caseId) return;
          if (!bankId) {
            addToCartVariant(caseId, withBankBtn);
            return;
          }
          addToCartItems(
            [
              { id: Number(bankId), quantity: 1 },
              { id: Number(caseId), quantity: 1 }
            ],
            withBankBtn,
            'Added both'
          );
        });
      }
    });
  }

  function bindCaseAddButtons(root) {
    bindCasePickers(root);
    root.querySelectorAll('[data-pmc-add-variant]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCartVariant(btn.getAttribute('data-pmc-add-variant'), btn);
      });
    });
  }

  function ctas(chipClass, items) {
    return (
      '<div class="' + chipClass.ctas + '">' +
      items
        .map(function (item) {
          if (item.action === 'show-all') {
            return (
              '<button type="button" class="' +
              chipClass.cta +
              '" data-pmc-show-all>' +
              item.label +
              '</button>'
            );
          }
          return (
            '<a class="' +
            chipClass.cta +
            '" href="' +
            item.href +
            '">' +
            item.label +
            '</a>'
          );
        })
        .join('') +
      '</div>'
    );
  }

  function statusRow(ok, label, detail) {
    var state = ok === true ? 'yes' : ok === false ? 'no' : 'maybe';
    var mark = state === 'yes' ? '✓' : state === 'no' ? '✗' : '?';
    return (
      '<li class="pmc__check pmc__check--' +
      state +
      '">' +
      '<span class="pmc__mark" aria-hidden="true">' +
      mark +
      '</span>' +
      '<span class="pmc__check-body">' +
      '<span class="pmc__check-label">' +
      label +
      '</span>' +
      '<span class="pmc__check-detail">' +
      detail +
      '</span>' +
      '</span>' +
      '</li>'
    );
  }

  function checklistHtml(caps) {
    var wirelessOk = caps.wireless === true ? true : caps.wireless === false ? false : null;
    var wirelessDetail =
      caps.wireless === true
        ? 'Yes: Qi / wireless charging supported'
        : caps.wireless === false
          ? 'No: this phone cannot charge wirelessly'
          : 'Check your phone specs for Qi wireless charging';

    var magnetOk = caps.magnet === 'native' ? true : caps.magnet === 'case' ? false : null;
    var magnetDetail =
      caps.magnet === 'native'
        ? 'Yes: built-in MagSafe / Qi2 magnets'
        : caps.magnet === 'case'
          ? 'No built-in magnets. Needs a MagSafe case'
          : 'Usually needs a MagSafe-compatible case';

    return (
      '<ul class="pmc__checks" role="list">' +
      statusRow(wirelessOk, 'Wireless charging', wirelessDetail) +
      statusRow(magnetOk, 'MagSafe snap', magnetDetail) +
      '</ul>'
    );
  }

  function resultHtmlPdp(brand, model, mode, urls, classes, catalog) {
    var device = mode === 'power_bank' ? 'power bank' : 'pad';
    var caps = phoneCaps(brand, model);
    var checks = checklistHtml(caps);
    var note = '';
    var links = [{ href: urls.cases, label: 'Browse phone cases' }];
    var pct = (catalog && catalog.offerPct) || 15;
    var offer = mode === 'power_bank';

    if (caps.wireless === false) {
      note =
        '<p class="pmc__note">Not compatible with this ' +
        device +
        '. Wireless charging is required.</p>';
      return checks + note;
    }

    if (caps.wireless === 'unknown') {
      note =
        '<p class="pmc__note">Only use this ' +
        device +
        ' if your phone supports Qi wireless charging.</p>';
      return checks + note + ctas(classes, links);
    }

    if (caps.magnet === 'native') {
      note =
        '<p class="pmc__note">' +
        model +
        ' has built-in magnets, so it can snap onto this ' +
        device +
        ' without a special case' +
        (offer
          ? '. A MagSafe case is optional — pick a colour below (15% off)'
          : '. A MagSafe case is optional — pick a colour below') +
        '.</p>';
      if (brand === 'google') {
        if (offer && catalog && catalog.pixel) {
          return (
            checks +
            note +
            caseOfferBlock(catalog.pixel, 'Pixel case', pct, model) +
            ctas(classes, [
              { href: urls.wallet, label: 'MagSafe card holder' },
              { href: urls.cases, label: 'Browse phone cases' }
            ])
          );
        }
        links = [
          { href: urls.pixel, label: 'Pixel magnetic case' },
          { href: urls.wallet, label: 'MagSafe card holder' },
          { href: urls.cases, label: 'Browse phone cases' }
        ];
        return checks + note + ctas(classes, links);
      }
      if (offer && catalog && catalog.iphone) {
        return (
          checks +
          note +
          caseOfferBlock(catalog.iphone, 'iPhone case', pct, model) +
          ctas(classes, [
            { href: urls.wallet, label: 'MagSafe card holder' },
            { href: urls.cases, label: 'Browse phone cases' }
          ])
        );
      }
      links = [
        { href: urls.iphone, label: 'iPhone MagSafe case' },
        { href: urls.wallet, label: 'MagSafe card holder' },
        { href: urls.cases, label: 'Browse phone cases' }
      ];
      return checks + note + ctas(classes, links);
    }

    if (brand === 'samsung') {
      var older = /s21|s22|s23\s*fe/i.test(model);
      var s25 = /s25/i.test(model);
      var caseUrl = older ? urls.samsungOlder : urls.samsungMain;
      var caseLabel = older ? 'S21–S24 magnetic case' : 'S23–S25 MagSafe case';
      var caseObj = older
        ? catalog && catalog.samsungOlder
        : catalog && catalog.samsungMain;
      note =
        '<p class="pmc__note">' +
        model +
        ' supports wireless charging, but needs a MagSafe case to snap onto this ' +
        device +
        '. Pick a colour below' +
        (offer
          ? ' (15% off)'
          : '') +
        '.</p>';
      if (caseObj) {
        var html =
          checks +
          note +
          casePickerHtml(caseObj, caseLabel, offer ? pct : 0, model, { withPowerBank: !!offer });
        if (s25 && catalog && catalog.samsungKick) {
          html += casePickerHtml(catalog.samsungKick, 'S25 kickstand case', offer ? pct : 0, model, {
            withPowerBank: !!offer
          });
        }
        html += ctas(classes, [{ href: urls.cases, label: 'Browse phone cases' }]);
        return html;
      }
      links = [
        { href: caseUrl, label: caseLabel },
        { href: urls.cases, label: 'Browse phone cases' }
      ];
      if (s25) links.splice(1, 0, { href: urls.samsungKick, label: 'S25 kickstand case' });
      return checks + note + ctas(classes, links);
    }

    if (brand === 'google') {
      note =
        '<p class="pmc__note">' +
        model +
        ' supports wireless charging, but needs a MagSafe case to snap onto this ' +
        device +
        '. Pick a colour below' +
        (offer
          ? ' (15% off)'
          : '') +
        '.</p>';
      if (catalog && catalog.pixel) {
        return (
          checks +
          note +
          casePickerHtml(catalog.pixel, 'Pixel case', offer ? pct : 0, model, {
            withPowerBank: !!offer
          }) +
          ctas(classes, [{ href: urls.cases, label: 'Browse phone cases' }])
        );
      }
      links = [
        { href: urls.pixel, label: 'Pixel magnetic case' },
        { href: urls.cases, label: 'Browse phone cases' }
      ];
      return checks + note + ctas(classes, links);
    }

    note =
      '<p class="pmc__note">If wireless charging is supported, add a MagSafe case for a secure hold.</p>';
    return checks + note + ctas(classes, links);
  }

  function resultHtmlCases(brand, model, urls, classes) {
    if (brand === 'apple') {
      return (
        '<p><strong>Cases for ' +
        model +
        '</strong></p>' +
        '<p>We stock MagSafe cases covering iPhone 13–17. Pick your exact model on the product page.</p>' +
        ctas(classes, [
          { href: urls.iphone, label: 'MagSafe Case for iPhone 13–17' },
          { href: urls.cases, label: 'Browse phone cases' }
        ])
      );
    }
    if (brand === 'samsung') {
      var older = /s21|s22|s23\s*fe/i.test(model);
      var s25 = /s25/i.test(model);
      if (older) {
        return (
          '<p><strong>Cases for ' +
          model +
          '</strong></p>' +
          '<p>Magnetic case covering Galaxy S21 FE through S24 Ultra. Choose your exact model on the product page.</p>' +
          ctas(classes, [{ href: urls.samsungOlder, label: 'Magnetic Case for Galaxy S21 FE–S24' }])
        );
      }
      var items = [{ href: urls.samsungMain, label: 'MagSafe Case for Galaxy S23–S25' }];
      if (s25) items.push({ href: urls.samsungKick, label: 'MagSafe Kickstand Case for Galaxy S25' });
      else items.push({ href: urls.samsungOlder, label: 'Also fits: S21 FE–S24 matrix' });
      return (
        '<p><strong>Cases for ' +
        model +
        '</strong></p>' +
        '<p>MagSafe case for Galaxy S23–S25' +
        (s25 ? ', plus an S25 kickstand option' : '') +
        '. Choose your exact model on the product page.</p>' +
        ctas(classes, items)
      );
    }
    if (brand === 'google') {
      if (/pixel 10/i.test(model)) {
        return (
          '<p><strong>Cases for ' +
          model +
          '</strong></p>' +
          '<p>Pixel 10, Pixel 10 Pro, and Pixel 10 Pro XL include a built-in magnetic ring, so MagSafe accessories snap without a special case. Optional magnetic case for protection and colour. Choose your exact model on the product page.</p>' +
          ctas(classes, [
            { href: urls.pixel, label: 'Magnetic Case for Google Pixel 6–10' },
            { href: urls.wallet, label: 'MagSafe card holder' }
          ])
        );
      }
      return (
        '<p><strong>Cases for ' +
        model +
        '</strong></p>' +
        '<p>Magnetic case covering Pixel 6–10. Older Pixel models need this case for MagSafe snap. Choose your exact model on the product page.</p>' +
        ctas(classes, [{ href: urls.pixel, label: 'Magnetic Case for Google Pixel 6–10' }])
      );
    }
    return (
      '<p><strong>No case listed for that phone yet.</strong></p>' +
      '<p>We currently stock MagSafe / magnetic cases for iPhone, Galaxy S21–S25, and Pixel 6–10.</p>' +
      ctas(classes, [{ action: 'show-all', label: 'Show all cases' }])
    );
  }

  function bindPicker(root, opts) {
    var brandsEl = root.querySelector(opts.brands);
    var seriesEl = root.querySelector(opts.series);
    var modelsEl = root.querySelector(opts.models);
    var step2 = root.querySelector(opts.step2);
    var step3 = root.querySelector(opts.step3);
    var resultEl = root.querySelector(opts.result);
    var externalBrands = !!opts.externalBrands;
    if ((!externalBrands && !brandsEl) || !seriesEl || !modelsEl || !resultEl) return;

    var brandKey = '';
    var seriesLabel = '';
    var brandScope = opts.brandScope || root;
    var brandButtons = function () {
      return brandScope.querySelectorAll('[data-mcl-brand]');
    };

    function hideResult() {
      resultEl.hidden = true;
      resultEl.innerHTML = '';
    }

    function hideModels() {
      modelsEl.hidden = true;
      modelsEl.innerHTML = '';
      if (step3) step3.hidden = true;
    }

    function showResult(model) {
      resultEl.hidden = false;
      resultEl.innerHTML = opts.resultHtml(brandKey, model);
      if (opts.onModel) opts.onModel(brandKey, model);
      var showAll = resultEl.querySelector('[data-pmc-show-all]');
      if (showAll && opts.onShowAll) {
        showAll.addEventListener('click', opts.onShowAll);
      }
      if (opts.onModel) opts.onModel(brandKey, model);
    }

    function pickSeries(series, seriesBtn) {
      seriesLabel = series.label;
      seriesEl.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', b === seriesBtn ? 'true' : 'false');
      });
      hideResult();
      hideModels();

      var models = series.models || [];
      if (opts.onSeries) opts.onSeries(brandKey, series.label);

      if (models.length === 1) {
        showResult(models[0]);
        return;
      }

      if (step3) step3.hidden = false;
      modelsEl.hidden = false;
      models.forEach(function (model) {
        var mbtn = document.createElement('button');
        mbtn.type = 'button';
        mbtn.className = opts.chipClass;
        mbtn.textContent = shortModelLabel(series.label, model);
        mbtn.setAttribute('data-pmc-model', model);
        mbtn.addEventListener('click', function () {
          modelsEl.querySelectorAll('button').forEach(function (c) {
            c.setAttribute('aria-selected', c === mbtn ? 'true' : 'false');
          });
          showResult(model);
        });
        modelsEl.appendChild(mbtn);
      });
    }

    function markBrandSelected(key, seriesHint) {
      var hint = seriesHint || '';
      brandButtons().forEach(function (b) {
        var match =
          b.getAttribute('data-mcl-brand') === key &&
          (b.getAttribute('data-mcl-series') || '') === hint;
        b.setAttribute('aria-pressed', match ? 'true' : 'false');
        b.classList.toggle('is-selected', match);
      });
      if (brandsEl) {
        brandsEl.querySelectorAll('[data-pmc-brand]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-pmc-brand') === key ? 'true' : 'false');
        });
      }
    }

    function selectBrand(key, seriesHint) {
      if (!CATALOG[key]) return;
      brandKey = key;
      seriesLabel = '';
      markBrandSelected(key, seriesHint || '');
      if (step2) step2.hidden = false;
      seriesEl.hidden = false;
      seriesEl.innerHTML = '';
      hideModels();
      hideResult();
      var list = seriesList(key);
      var preferred = null;
      list.forEach(function (series) {
        var sbtn = document.createElement('button');
        sbtn.type = 'button';
        sbtn.className = opts.chipClass;
        sbtn.textContent = series.label;
        sbtn.setAttribute('data-pmc-series', series.label);
        sbtn.addEventListener('click', function () {
          pickSeries(series, sbtn);
        });
        seriesEl.appendChild(sbtn);
        if (seriesHint && series.label === seriesHint) preferred = { series: series, btn: sbtn };
      });
      if (opts.onBrand) opts.onBrand(key, seriesHint || '');
      if (preferred) {
        pickSeries(preferred.series, preferred.btn);
      }
      if (opts.scrollToSeries && seriesEl.scrollIntoView) {
        try {
          seriesEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) {
          seriesEl.scrollIntoView(true);
        }
      }
    }

    if (externalBrands) {
      brandButtons().forEach(function (btn) {
        if (btn.dataset.mclBrandBound) return;
        btn.dataset.mclBrandBound = '1';
        btn.addEventListener('click', function () {
          selectBrand(
            btn.getAttribute('data-mcl-brand'),
            btn.getAttribute('data-mcl-series') || ''
          );
        });
      });
    } else {
      Object.keys(CATALOG).forEach(function (key) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = opts.chipClass;
        btn.textContent = CATALOG[key].label;
        btn.setAttribute('data-pmc-brand', key);
        btn.addEventListener('click', function () {
          selectBrand(key);
        });
        brandsEl.appendChild(btn);
      });
    }

    return {
      selectBrand: selectBrand,
      resetUi: function () {
        brandKey = '';
        seriesLabel = '';
        brandButtons().forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });
        if (brandsEl) {
          brandsEl.querySelectorAll('button').forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });
        }
        seriesEl.hidden = true;
        seriesEl.innerHTML = '';
        if (step2) step2.hidden = true;
        hideModels();
        hideResult();
      }
    };
  }

  function initPdp(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var mode = root.getAttribute('data-compat-mode') || 'pad';
    var urls = urlsFromRoot(root);
    var catalog = parseCaseCatalog(root);
    var classes = { ctas: 'pmc__ctas', cta: 'pmc__cta' };
    var resultEl = root.querySelector('[data-pmc-result]');
    bindPicker(root, {
      brands: '[data-pmc-brands]',
      series: '[data-pmc-series]',
      models: '[data-pmc-models]',
      step2: '[data-pmc-step2]',
      step3: '[data-pmc-step3]',
      result: '[data-pmc-result]',
      chipClass: 'pmc__chip',
      resultHtml: function (brand, model) {
        return resultHtmlPdp(brand, model, mode, urls, classes, catalog);
      },
      onModel: function () {
        if (resultEl) bindCaseAddButtons(resultEl);
      }
    });
    // also bind after any result paint
    if (resultEl) {
      var obs = new MutationObserver(function () {
        bindCaseAddButtons(resultEl);
      });
      obs.observe(resultEl, { childList: true, subtree: true });
    }
  }

  function markCards() {
    var nodes = document.querySelectorAll(
      '.main-collection a[href*="/products/"], .product-grid a[href*="/products/"], product-card a[href*="/products/"], results-list a[href*="/products/"]'
    );
    var cards = new Set();
    nodes.forEach(function (a) {
      var el =
        a.closest('li, product-card, .product-card, .resource-list__item, [data-product-id]') ||
        a.parentElement;
      if (!el) return;
      el.setAttribute('data-qi2c-card', '1');
      var handle = (a.getAttribute('href') || '').toLowerCase();
      el.dataset.qi2cHandle = handle;
      var brands = [];
      if (handle.indexOf('iphone') !== -1 || handle.indexOf('i-phone') !== -1) brands.push('brand:apple');
      if (handle.indexOf('pixel') !== -1) brands.push('brand:google');
      if (
        handle.indexOf('s25') !== -1 ||
        handle.indexOf('s24') !== -1 ||
        handle.indexOf('s23') !== -1 ||
        handle.indexOf('galaxy') !== -1 ||
        handle.indexOf('s22') !== -1 ||
        handle.indexOf('s21') !== -1
      ) {
        brands.push('brand:samsung');
      }
      if (handle.indexOf('card-holder') !== -1 || handle.indexOf('magnetic-ring') !== -1) {
        brands.push('brand:apple', 'magsafe-wallet');
      }
      el.dataset.qi2cBrands = brands.join(' ');
      cards.add(el);
    });
    return cards;
  }

  function handleMatches(handle, brand, model) {
    var m = (model || '').toLowerCase();
    var isWallet = handle.indexOf('card-holder') !== -1 || handle.indexOf('magnetic-ring') !== -1;
    if (brand === 'apple') {
      return handle.indexOf('iphone') !== -1 || handle.indexOf('i-phone') !== -1 || isWallet;
    }
    if (brand === 'google') return handle.indexOf('pixel') !== -1;
    if (brand === 'samsung') {
      if (isWallet) return false;
      if (/s21|s22/.test(m)) {
        return handle.indexOf('oil-injection') !== -1 || handle.indexOf('s24-phone-case-magnetic') !== -1;
      }
      if (/s25/.test(m)) {
        return (
          handle.indexOf('fine-circle') !== -1 ||
          handle.indexOf('oblique-turning') !== -1 ||
          handle.indexOf('s25ultra-magnetic') !== -1
        );
      }
      return (
        handle.indexOf('fine-circle') !== -1 ||
        handle.indexOf('oil-injection') !== -1 ||
        handle.indexOf('s24-phone-case-magnetic') !== -1
      );
    }
    return false;
  }

  function initCaseFinder(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var urls = urlsFromRoot(root);
    var noteEl = root.querySelector('[data-qi2c-filter-note]');
    var resetBtn = root.querySelector('[data-qi2c-reset]');
    var classes = { ctas: 'qi2c__ctas', cta: 'qi2c__cta' };

    function filterBy(brand, model) {
      document.body.classList.add('qi2c-filtering');
      var cards = markCards();
      var shown = 0;
      cards.forEach(function (el) {
        var handle = el.dataset.qi2cHandle || '';
        var brands = el.dataset.qi2cBrands || '';
        var ok;
        if (!model) {
          ok = brands.indexOf(CATALOG[brand].filter) !== -1;
          if (
            brand === 'apple' &&
            (handle.indexOf('card-holder') !== -1 || brands.indexOf('magsafe-wallet') !== -1)
          ) {
            ok = true;
          }
        } else {
          ok = handleMatches(handle, brand, model);
        }
        el.setAttribute('data-qi2c-hidden', ok ? 'false' : 'true');
        if (ok) shown += 1;
      });
      if (noteEl) {
        noteEl.hidden = false;
        noteEl.textContent = shown
          ? model
            ? 'Showing cases we stock for ' + model + '.'
            : 'Showing cases for ' + CATALOG[brand].label + '. Pick a series to narrow further.'
          : 'No case for that model in this collection yet. Try another model or show all cases.';
      }
      if (resetBtn) resetBtn.hidden = false;
    }

    function clearFilter() {
      document.body.classList.remove('qi2c-filtering');
      document.querySelectorAll('[data-qi2c-card]').forEach(function (el) {
        el.setAttribute('data-qi2c-hidden', 'false');
      });
      if (noteEl) noteEl.hidden = true;
      if (resetBtn) resetBtn.hidden = true;
    }

    var picker = bindPicker(root, {
      brands: '[data-qi2c-brands]',
      series: '[data-qi2c-series]',
      models: '[data-qi2c-models]',
      step2: '[data-qi2c-step2]',
      step3: '[data-qi2c-step3]',
      result: '[data-qi2c-result]',
      chipClass: 'qi2c__chip',
      resultHtml: function (brand, model) {
        return resultHtmlCases(brand, model, urls, classes);
      },
      onBrand: function (key) {
        filterBy(key, '');
      },
      onSeries: function (brand, series) {
        // Narrow with a representative model name from the series label (S24 / Pixel 9 / etc.)
        filterBy(brand, series);
      },
      onModel: function (brand, model) {
        filterBy(brand, model);
      },
      onShowAll: function () {
        if (resetBtn) resetBtn.click();
      }
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        clearFilter();
        if (picker) picker.resetUi();
      });
    }

    markCards();
  }

  function cartCaseCard(caseObj, label, pct, model) {
    return casePickerHtml(caseObj, label, pct, model, { withPowerBank: false });
  }

  function resultHtmlCartUpsell(brand, model, catalog) {
    var pct = (catalog && catalog.offerPct) || 15;
    var key = caseKeyFor(brand, model);
    if (!key || !catalog || !catalog[key]) {
      return (
        '<p class="mcu__note">No MagSafe case listed for that phone yet. ' +
        '<a class="mcu__link" href="' +
        DEFAULT_URLS.cases +
        '">Browse cases</a></p>'
      );
    }
    var label =
      key === 'iphone'
        ? 'iPhone MagSafe case'
        : key === 'pixel'
          ? 'Pixel magnetic case'
          : key === 'samsungOlder'
            ? 'S21–S24 magnetic case'
            : 'S23–S25 MagSafe case';
    var html =
      '<p class="mcu__note">Recommended for ' +
      model +
      ':</p>' +
      cartCaseCard(catalog[key], label, pct, model);
    if (brand === 'samsung' && /s25/i.test(model) && catalog.samsungKick) {
      html += cartCaseCard(catalog.samsungKick, 'S25 kickstand case', pct, model);
    }
    return html;
  }

  function initCartUpsell(root) {
    if (!root || root.dataset.ready) return;
    // Don't mark ready until the picker mounts — morph can insert the shell first.
    var brandsEl = root.querySelector('[data-mcu-brands]');
    var seriesEl = root.querySelector('[data-mcu-series]');
    var modelsEl = root.querySelector('[data-mcu-models]');
    var matchEl = root.querySelector('[data-mcu-match]');
    var brandTiles = root.querySelectorAll('[data-mcl-brand]');
    var externalBrands = brandTiles.length > 0;
    if (!seriesEl || !modelsEl || !matchEl) return;
    if (!externalBrands) {
      if (!brandsEl) return;
      if (brandsEl.children.length) {
        root.dataset.ready = '1';
        return;
      }
    }

    var catalog = parseCaseCatalog(root);
    var picker = bindPicker(root, {
      brands: '[data-mcu-brands]',
      series: '[data-mcu-series]',
      models: '[data-mcu-models]',
      step2: '[data-mcu-step2]',
      step3: '[data-mcu-step3]',
      result: '[data-mcu-match]',
      chipClass: 'mcu__chip',
      externalBrands: externalBrands,
      brandScope: root,
      scrollToSeries: externalBrands,
      resultHtml: function (brand, model) {
        return resultHtmlCartUpsell(brand, model, catalog);
      }
    });
    if (!picker) return;
    if (!externalBrands && brandsEl && !brandsEl.children.length) return;
    root.dataset.ready = '1';

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        bindCaseAddButtons(root);
      }).observe(matchEl, { childList: true, subtree: true });
    }
  }

  function caseLabelForKey(key) {
    if (key === 'iphone') return 'iPhone MagSafe case';
    if (key === 'pixel') return 'Pixel magnetic case';
    if (key === 'samsungOlder') return 'S21–S24 magnetic case';
    return 'S23–S25 MagSafe case';
  }

  function resultHtmlCasesLanding(brand, model, catalog, urls, classes) {
    var caps = phoneCaps(brand, model);
    var checks = checklistHtml(caps);
    var note;
    if (caps.magnet === 'native') {
      note =
        model +
        ' has built-in MagSafe / Qi2 magnets. A MagSafe case is optional for protection and colour.';
    } else if (caps.magnet === 'case') {
      note =
        model +
        ' needs a MagSafe case for a secure snap onto MagSafe accessories.';
    } else {
      note =
        'A MagSafe-compatible case gives a secure snap for MagSafe accessories on ' +
        model +
        '.';
    }

    var key = caseKeyFor(brand, model);
    var casesHtml = '';
    if (key && catalog && catalog[key]) {
      casesHtml =
        '<p class="mcl__section-title">Cases for ' +
        escAttr(model) +
        '</p>' +
        casePickerHtml(catalog[key], caseLabelForKey(key), 0, model, {
          withPowerBank: false
        });
      if (brand === 'samsung' && /s25/i.test(model) && catalog.samsungKick) {
        casesHtml += casePickerHtml(catalog.samsungKick, 'S25 kickstand case', 0, model, {
          withPowerBank: false
        });
      }
    } else {
      casesHtml =
        '<p class="pmc__note">No MagSafe case listed for that phone yet. ' +
        '<a class="pmc__cta" href="' +
        (urls.cases || DEFAULT_URLS.cases) +
        '">Browse cases</a></p>';
    }

    var accessories = ctas(classes, [
      { href: urls.wallet || DEFAULT_URLS.wallet, label: 'MagSafe card holder' }
    ]);

    return (
      '<div class="mcl__report">' +
      '<p class="mcl__section-title">Compatibility for ' +
      escAttr(model) +
      '</p>' +
      checks +
      '<p class="pmc__note">' +
      escAttr(note) +
      '</p>' +
      '</div>' +
      '<div class="mcl__cases">' +
      casesHtml +
      '</div>' +
      '<div class="mcl__accessories">' +
      '<p class="mcl__section-title">Works with your case</p>' +
      '<p class="pmc__note">Attachments that snap once you have a matching MagSafe case.</p>' +
      accessories +
      '</div>'
    );
  }

  function initCasesLanding(root) {
    if (!root || root.dataset.ready) return;
    var seriesEl = root.querySelector('[data-mcu-series]');
    var modelsEl = root.querySelector('[data-mcu-models]');
    var matchEl = root.querySelector('[data-mcu-match]');
    var page = root.closest('[data-magsafe-cases-page]') || root;
    var brandTiles = page.querySelectorAll('[data-mcl-brand]');
    if (!seriesEl || !modelsEl || !matchEl || !brandTiles.length) return;

    var catalog = parseCaseCatalog(root);
    var urls = urlsFromRoot(root);
    var classes = { ctas: 'pmc__ctas', cta: 'pmc__cta' };
    var picker = bindPicker(root, {
      brands: '[data-mcu-brands]',
      series: '[data-mcu-series]',
      models: '[data-mcu-models]',
      step2: '[data-mcu-step2]',
      step3: '[data-mcu-step3]',
      result: '[data-mcu-match]',
      chipClass: 'mcu__chip',
      externalBrands: true,
      brandScope: page,
      scrollToSeries: true,
      resultHtml: function (brand, model) {
        return resultHtmlCasesLanding(brand, model, catalog, urls, classes);
      },
      onModel: function () {
        bindCaseAddButtons(matchEl);
      }
    });
    if (!picker) return;
    root.dataset.ready = '1';

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        bindCaseAddButtons(matchEl);
      }).observe(matchEl, { childList: true, subtree: true });
    }
  }

  function autoInit() {
    document.querySelectorAll('[data-phone-magnetic-compat]').forEach(initPdp);
    document.querySelectorAll('[data-phone-case-finder]').forEach(initCaseFinder);
    document.querySelectorAll('[data-magsafe-case-upsell]').forEach(initCartUpsell);
    document.querySelectorAll('[data-magsafe-cases-landing]').forEach(initCasesLanding);
  }

  var scheduleAutoInit = (function () {
    var t = null;
    return function scheduleAutoInit(delay) {
      clearTimeout(t);
      t = setTimeout(autoInit, delay == null ? 80 : delay);
    };
  })();

  function watchCartUpsellMount() {
    if (watchCartUpsellMount.bound) return;
    watchCartUpsellMount.bound = true;

    document.addEventListener('cart:update', function () {
      scheduleAutoInit(120);
    });
    document.addEventListener('cart:refresh', function () {
      scheduleAutoInit(120);
    });
    // Horizon / Shopify standard cart events (line remove/update morphs the section).
    document.addEventListener('shopify:cart:lines-update', function (event) {
      var promise = event && event.promise;
      if (promise && typeof promise.then === 'function') {
        promise
          .then(function () {
            scheduleAutoInit(120);
          })
          .catch(function () {
            scheduleAutoInit(200);
          });
      } else {
        scheduleAutoInit(200);
      }
    });

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (!node || node.nodeType !== 1) continue;
            if (
              (node.matches && node.matches('[data-magsafe-case-upsell]')) ||
              (node.querySelector && node.querySelector('[data-magsafe-case-upsell]'))
            ) {
              scheduleAutoInit(50);
              return;
            }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  global.PhoneMagneticCompat = {
    CATALOG: CATALOG,
    DEFAULT_URLS: DEFAULT_URLS,
    initPdp: initPdp,
    initCaseFinder: initCaseFinder,
    initCartUpsell: initCartUpsell,
    initCasesLanding: initCasesLanding,
    autoInit: autoInit,
    notifyCartLinesUpdate: notifyCartLinesUpdate,
    swatchStyle: swatchStyle,
    cartAdd: cartAdd,
    cartChange: cartChange,
    cartUpdate: cartUpdate,
    cartAddWithSections: cartAddWithSections,
    cartChangeWithSections: cartChangeWithSections,
    refreshCartSections: refreshCartSections,
    fetchCartSections: fetchCartSections,
    applySectionsHtml: applySectionsHtml,
    updateCartBubble: updateCartBubble,
    fetchCartJson: fetchCartJson,
    openCartDrawer: openCartDrawer,
    addToCartItems: addToCartItems,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoInit();
      watchCartUpsellMount();
    });
  } else {
    autoInit();
    watchCartUpsellMount();
  }
})(window);
